import React from "react"

const LoadingState = () => (
  <div className="flex flex-col gap-3" aria-busy="true">
    {[0, 1, 2].map((i) => (
      <div key={i} className="flex gap-3">
        <div className="h-8 w-8 shrink-0 animate-pulse rounded-full bg-gray-200" />
        <div className="flex-1 space-y-2">
          <div className="h-3 w-1/3 animate-pulse rounded bg-gray-200" />
          <div className="h-3 w-3/4 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    ))}
  </div>
)

export default LoadingState
